import Image from 'next/future/image';
import settings from '@/settings';
import { APAC_CONTENT, NA_CONTENT } from '@/lib/featured-client-helper';

const FeaturedClientBox = (props: {
  title: string;
  imageSrc: string;
  articleUrl: string;
}) => {
  const { title, imageSrc, articleUrl } = props;

  return (
    <a rel="noopener noreferrer" target="_blank" href={articleUrl}>
      <div className="relative flex h-7 items-center justify-center xs:h-8 md:h-12 lg:h-10">
        <Image
          src={imageSrc}
          alt={title}
          className="h-full w-full object-contain"
          fill
        />
      </div>
    </a>
  );
};

export default function FeaturedClient() {
  const content = ['reebelo-us', 'reebelo-ca'].includes(settings.store)
    ? NA_CONTENT
    : APAC_CONTENT;

  return (
    <div className="grid grid-cols-3 gap-x-2 gap-y-4 xs:gap-x-4 xs:gap-y-8 md:grid-cols-6 lg:gap-10">
      {content.map((client) => (
        <FeaturedClientBox
          title={client.title}
          imageSrc={client.img}
          key={client.title}
          articleUrl={client.articleUrl}
        />
      ))}
    </div>
  );
}
